
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2704',
  depVersions: {
  "customer-portal-app": "static-1.2704",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.482",
  "data-fetching-client": "static-1.9787",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25739",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5718",
  "hs-test-utils": "static-1.8145",
  "hub-http": "static-1.6348",
  "hub-http-shared-msw-handlers": "static-1.10272",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18589",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11596",
  "I18n": "static-7.1640",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6583",
  "payment-link-components": "static-1.23837",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7193",
  "quartz-core": "static-1.6412",
  "quartz-i18n": "static-1.868",
  "react": "static-7.187",
  "react-colorpicker": "static-2.10333",
  "react-dlb": "static-1.81",
  "react-utils": "static-2.5434",
  "rich-text-lib": "static-1.20050",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18165",
  "ui-components-test-utils": "static-1.5733",
  "UIComponents": "static-3.8542",
  "foundations-assets": "static-1.4999",
  "foundations-components": "static-1.8184",
  "foundations-theming": "static-1.4558",
  "foundations-theming-specialty": "static-1.2274",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1181",
  "quartz-config": "static-1.971",
  "quartz-routing": "static-1.623",
  "quick-fetch": "static-1.4010",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-feature-id-1459-lcp-embedded-fields.3",
  "rpc-client-utils": "static-1.4782",
  "sanitize-text": "static-1.8272",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4885",
  "ui-addon-react-router-dom": "static-1.9662",
  "usage-tracker": "static-1.7476",
  "usage-tracker-anonymous": "static-1.5893",
  "usage-tracker-core": "static-1.7326",
  "video-components-external": "static-1.11679",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3492",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3470",
  "quartz-webpack": "static-1.3417",
  "bend-plugin-quartz-routing": "static-1.271",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7804",
  "frontend-preferences-client": "static-1.8052",
  "laboratory-lib": "static-3.7278",
  "onboarding-scopes": "static-1.6586",
  "seat-types-lib": "static-1.288",
  "ui-addon-opt": "static-4.8487",
  "HeadJS": "static-2.772",
  "hs-test-utils-bend-plugin": "static-1.3256",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.174",
  "ts-schema": "static-1.4174",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7955",
  "content-media-capture": "static-1.4889",
  "cssUtils": "static-1.827",
  "customer-data-ui-utilities": "static-1.9950",
  "file-manager-components": "static-1.23969",
  "HubStyle": "static-2.11903",
  "knowledge-content-types": "static-1.8559",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.489",
  "ui-addon-emoji-picker": "static-1.10012",
  "ui-addon-i18n": "static-1.11274",
  "ui-business-units-lib": "static-1.9192",
  "ui-shepherd-react": "static-3.10379",
  "video-data-lib": "static-1.35337",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4451",
  "commerce-tours-lib": "static-1.6330",
  "customer-data-properties": "static-1.51988",
  "getting-started-shared-tasks": "static-1.18754",
  "growth-onboarding-reliability": "static-1.5207",
  "onboarding-tours": "static-1.16838",
  "reference-resolvers-lite": "static-1.8222",
  "sales-checkout-service-client": "static-1.3718",
  "ui-addon-iframeable": "static-1.9192",
  "user-context": "static-1.5234",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.847",
  "hubspotter-http": "static-1.4743",
  "icons": "static-2.655",
  "mobile-manifest-mixins": "static-1.546",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.868",
  "quartz-head": "static-1.858",
  "quartz-test": "static-1.868",
  "quartz-tracking": "static-1.572",
  "trellis-components": "static-1.2226",
  "ui-fonts": "static-1.858",
  "usage-tracker-container": "static-1.7466",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9549",
  "data-token-picker": "static-1.16632",
  "FileManagerLib": "static-1.39609",
  "property-translator": "static-1.5522",
  "atom": "static-1.5201",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6105",
  "salesImages": "static-1.527",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5667",
  "react-create-root-preference": "static-1.38",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1185",
  "bend-plugin-foundations-components": "static-1.4453",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "trellis-assets": "static-1.2207",
  "bend-plugin-foundations-theming": "static-1.3041",
  "foundations-theming-base": "static-1.3543",
  "stylex": "static-1.35",
  "interframe": "static-3.4885",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5890",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.192",
  "chirp-fetch": "static-1.2013",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4602",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4777",
  "content-media-composition-data-lib": "static-1.12693",
  "content-media-compositions": "static-2.16700",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4275",
  "magpie-lib": "static-1.5635",
  "magpie-types": "static-1.5095",
  "media-bridge-lib": "static-1.19145",
  "bender-build-tools": "static-1.3297",
  "inbound-db-properties-service-client": "static-1.3939",
  "superstore": "static-1.4885",
  "feedback-loader": "static-1.29533",
  "ai-components-ui-library": "static-1.9270",
  "ui-addon-video-player": "static-1.8830",
  "ui-coaching-tips": "static-1.28902",
  "ContentUtils": "static-1.68729",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4551",
  "sassPrefix": "static-1.158",
  "react-dnd-compat": "static-1.4740",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1147",
  "copilot-toolkit": "static-1.11454",
  "avatar-components": "static-1.2624",
  "navigation-messaging": "static-1.7641",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8301",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.10024",
  "crm-message-bus": "static-1.43308",
  "growth-data-modal": "static-1.5633",
  "hubspot-apollo-client": "static-1.5003",
  "onboarding-tours-client": "static-1.5052",
  "calling-global-api": "static-1.64931",
  "calling-internal-common": "static-1.31436",
  "calling-lifecycle-internal": "static-1.66313",
  "calling-lifecycle-messages": "static-1.58607",
  "conditional-properties-service-client": "static-1.3890",
  "crm-links": "static-1.6434",
  "crm-pipelines-api-client-types": "static-1.4229",
  "customer-data-objects-ui-components": "static-1.13154",
  "customer-data-properties-shared-msw-handlers": "static-1.9599",
  "customer-data-property-utils": "static-1.8220",
  "external-options-client-types": "static-1.4219",
  "framework-data-schema-resolvers": "static-1.7019",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.301",
  "inbound-db-meta-service-client": "static-1.3679",
  "inbounddb-objects-service-types": "static-1.4310",
  "meetings-icalendar-utils-lib": "static-1.758",
  "multi-currency-client-types": "static-1.3783",
  "object-builder-ui-client": "static-1.49168",
  "pipeline-validation-client-types": "static-1.4058",
  "property-value-citations": "static-1.2602",
  "pulse": "static-1.729",
  "smart-property-lib": "static-1.7884",
  "tiered-pricing": "static-1.1544",
  "ui-addon-form-validation": "static-1.11116",
  "zustand": "static-1.74",
  "growth-onboarding-confetti": "static-1.3191",
  "growth-onboarding-next-action-utils": "static-1.2270",
  "navigation-components": "static-1.18314",
  "onboarding-tours-utils": "static-1.904",
  "ui-shepherd-tracker": "static-1.7760",
  "ui-universal-auth": "static-1.9129",
  "batch-promise": "static-1.1669",
  "getting-started-shared-tasks-store": "static-1.17872",
  "hubspotter-http-shared-msw-handlers": "static-1.10270",
  "usage-tracker-session-replay": "static-1.5162",
  "base-ui": "static-1.14",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1066",
  "tanstack-virtual": "static-1.31",
  "audio-components": "static-1.6111",
  "FileManagerCore": "static-1.39468",
  "FileManagerImages": "static-1.37120",
  "video-components": "static-1.13681",
  "foundations-components-legacy": "static-1.1209",
  "purchase-motions-api": "static-1.6108",
  "signup-constants": "static-1.19162",
  "signup-ui-url-generator": "static-2.8183",
  "usage-tracker-public": "static-1.7287",
  "reactive-lib": "static-1.851",
  "simple-logging-lib": "static-1.3174",
  "chatspot-core": "static-1.21897",
  "growth-onboarding-feedback-components": "static-1.6704",
  "cms-field-types": "static-1.4940",
  "content-icons-ui": "static-1.2261",
  "integrations-lib": "static-1.16544",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.425",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.901",
  "customer-data-tracking": "static-1.7012",
  "products-iframe-lib": "static-1.8273",
  "products-ui-components-shared-msw-handlers": "static-1.10654",
  "restore-request-side-panel-lib": "static-1.1190",
  "onboarding-data-sync-lib": "static-1.2181",
  "hubspot-apollo-cache": "static-1.462",
  "calling-error-reporting": "static-1.31443",
  "shared-worker-versioning": "static-1.11161",
  "calling-usage-tracker": "static-1.6669",
  "voice-sms-access-library": "static-1.1461",
  "conversations-skeleton-state": "static-1.7372",
  "location-customization-utils-lib": "static-1.9613",
  "fdsr-migration-layer": "static-1.138",
  "framework-builder-read-service-client": "static-1.4097",
  "framework-data-schema-quick-fetch": "static-1.6924",
  "persist-promise": "static-1.3826",
  "event-emitter": "static-1.1075",
  "bend-plugin-pulse": "static-1.232",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.405",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10355",
  "fsm": "static-1.3856",
  "policy-lib": "static-1.6911",
  "react-tinymce": "static-1.55571",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10418",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54697",
  "tinymce-plugins": "static-1.57811",
  "tinymce-themes": "static-1.56667",
  "growth-onboarding-next-action-components": "static-1.2298",
  "user-context-client": "static-1.4705",
  "nest": "static-1.358",
  "unified-auth-core-lib": "static-1.925",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4661",
  "video-embed": "static-1.36171",
  "social-insights-client-types": "static-1.22366",
  "flux-actions": "static-1.347",
  "integrations-error-boundary-lib": "static-1.13959",
  "integrations-tracking-lib": "static-1.5732",
  "native-integrations-shared-strings": "static-1.7907",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10487",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.643",
  "sales-views-client-types": "static-1.4382",
  "InboxConnectUtils": "static-4.15138",
  "meetings-connect-utils-lib": "static-1.7730",
  "calling-orchestration-schema": "static-1.36238",
  "crm-record-cards-service-types": "static-1.3678",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4636",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3168",
  "tinymce-data": "static-1.40782",
  "ui-addon-sales-email": "static-1.5336",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12690",
  "layout-dnd-utils": "static-1.11665",
  "react-codemirror": "static-1.10753",
  "ui-brand-identity-lib": "static-1.15726",
  "NamespacedHubStyle": "static-2.9146",
  "outpost": "static-1.4293",
  "universal-page-editor-lib": "static-1.3137",
  "adobe-sign-auth-lib": "static-1.36",
  "ads-unified-auth-lib": "static-1.409",
  "google-sheets-integration-lib": "static-1.600",
  "microsoft-drive-integration-lib": "static-1.745",
  "surveymonkey-integration-lib": "static-1.55",
  "slack-ui-library": "static-1.10522",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68804",
  "layout-data-lib": "static-1.9990",
  "browser-eslint": "static-2.57",
  "advanced-menus-core": "static-1.15339",
  "advanced-menus-lib": "static-1.12250",
  "ExportDialog": "static-6.10505",
  "ui-memberships-settings-lib": "static-1.34373",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15338",
  "simple-menus-lib": "static-1.16855"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2704",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.482",
  "data-fetching-client": "/data-fetching-client/static-1.9787",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25739",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5718",
  "hs-test-utils": "/hs-test-utils/static-1.8145",
  "hub-http": "/hub-http/static-1.6348",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10272",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18589",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11596",
  "I18n": "/I18n/static-7.1640",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6583",
  "payment-link-components": "/payment-link-components/static-1.23837",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7193",
  "quartz-core": "/quartz-core/static-1.6412",
  "quartz-i18n": "/quartz-i18n/static-1.868",
  "react": "/react/static-7.187",
  "react-colorpicker": "/react-colorpicker/static-2.10333",
  "react-dlb": "/react-dlb/static-1.81",
  "react-utils": "/react-utils/static-2.5434",
  "rich-text-lib": "/rich-text-lib/static-1.20050",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18165",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5733",
  "UIComponents": "/UIComponents/static-3.8542",
  "foundations-assets": "/foundations-assets/static-1.4999",
  "foundations-components": "/foundations-components/static-1.8184",
  "foundations-theming": "/foundations-theming/static-1.4558",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2274",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1181",
  "quartz-config": "/quartz-config/static-1.971",
  "quartz-routing": "/quartz-routing/static-1.623",
  "quick-fetch": "/quick-fetch/static-1.4010",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-lcp-embedded-fields.3",
  "rpc-client-utils": "/rpc-client-utils/static-1.4782",
  "sanitize-text": "/sanitize-text/static-1.8272",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4885",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9662",
  "usage-tracker": "/usage-tracker/static-1.7476",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5893",
  "usage-tracker-core": "/usage-tracker-core/static-1.7326",
  "video-components-external": "/video-components-external/static-1.11679",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3492",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3470",
  "quartz-webpack": "/quartz-webpack/static-1.3417",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.271",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7804",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8052",
  "laboratory-lib": "/laboratory-lib/static-3.7278",
  "onboarding-scopes": "/onboarding-scopes/static-1.6586",
  "seat-types-lib": "/seat-types-lib/static-1.288",
  "ui-addon-opt": "/ui-addon-opt/static-4.8487",
  "HeadJS": "/HeadJS/static-2.772",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3256",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.174",
  "ts-schema": "/ts-schema/static-1.4174",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7955",
  "content-media-capture": "/content-media-capture/static-1.4889",
  "cssUtils": "/cssUtils/static-1.827",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9950",
  "file-manager-components": "/file-manager-components/static-1.23969",
  "HubStyle": "/HubStyle/static-2.11903",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10012",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11274",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9192",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10379",
  "video-data-lib": "/video-data-lib/static-1.35337",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4451",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6330",
  "customer-data-properties": "/customer-data-properties/static-1.51988",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18754",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5207",
  "onboarding-tours": "/onboarding-tours/static-1.16838",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8222",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3718",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9192",
  "user-context": "/user-context/static-1.5234",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.847",
  "hubspotter-http": "/hubspotter-http/static-1.4743",
  "icons": "/icons/static-2.655",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.546",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.868",
  "quartz-head": "/quartz-head/static-1.858",
  "quartz-test": "/quartz-test/static-1.868",
  "quartz-tracking": "/quartz-tracking/static-1.572",
  "trellis-components": "/trellis-components/static-1.2226",
  "ui-fonts": "/ui-fonts/static-1.858",
  "usage-tracker-container": "/usage-tracker-container/static-1.7466",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9549",
  "data-token-picker": "/data-token-picker/static-1.16632",
  "FileManagerLib": "/FileManagerLib/static-1.39609",
  "property-translator": "/property-translator/static-1.5522",
  "atom": "/atom/static-1.5201",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6105",
  "salesImages": "/salesImages/static-1.527",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5667",
  "react-create-root-preference": "/react-create-root-preference/static-1.38",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1185",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4453",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "trellis-assets": "/trellis-assets/static-1.2207",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3041",
  "foundations-theming-base": "/foundations-theming-base/static-1.3543",
  "stylex": "/stylex/static-1.35",
  "interframe": "/interframe/static-3.4885",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5890",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.192",
  "chirp-fetch": "/chirp-fetch/static-1.2013",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4602",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4777",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12693",
  "content-media-compositions": "/content-media-compositions/static-2.16700",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4275",
  "magpie-lib": "/magpie-lib/static-1.5635",
  "magpie-types": "/magpie-types/static-1.5095",
  "media-bridge-lib": "/media-bridge-lib/static-1.19145",
  "bender-build-tools": "/bender-build-tools/static-1.3297",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3939",
  "superstore": "/superstore/static-1.4885",
  "feedback-loader": "/feedback-loader/static-1.29533",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9270",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8830",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28902",
  "ContentUtils": "/ContentUtils/static-1.68729",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4551",
  "sassPrefix": "/sassPrefix/static-1.158",
  "react-dnd-compat": "/react-dnd-compat/static-1.4740",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1147",
  "copilot-toolkit": "/copilot-toolkit/static-1.11454",
  "avatar-components": "/avatar-components/static-1.2624",
  "navigation-messaging": "/navigation-messaging/static-1.7641",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8301",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.10024",
  "crm-message-bus": "/crm-message-bus/static-1.43308",
  "growth-data-modal": "/growth-data-modal/static-1.5633",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5003",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5052",
  "calling-global-api": "/calling-global-api/static-1.64931",
  "calling-internal-common": "/calling-internal-common/static-1.31436",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66313",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58607",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3890",
  "crm-links": "/crm-links/static-1.6434",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4229",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13154",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9599",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8220",
  "external-options-client-types": "/external-options-client-types/static-1.4219",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7019",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.301",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3679",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4310",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.758",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3783",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49168",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4058",
  "property-value-citations": "/property-value-citations/static-1.2602",
  "pulse": "/pulse/static-1.729",
  "smart-property-lib": "/smart-property-lib/static-1.7884",
  "tiered-pricing": "/tiered-pricing/static-1.1544",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11116",
  "zustand": "/zustand/static-1.74",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3191",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2270",
  "navigation-components": "/navigation-components/static-1.18314",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.904",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7760",
  "ui-universal-auth": "/ui-universal-auth/static-1.9129",
  "batch-promise": "/batch-promise/static-1.1669",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17872",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10270",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5162",
  "base-ui": "/base-ui/static-1.14",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1066",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "audio-components": "/audio-components/static-1.6111",
  "FileManagerCore": "/FileManagerCore/static-1.39468",
  "FileManagerImages": "/FileManagerImages/static-1.37120",
  "video-components": "/video-components/static-1.13681",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1209",
  "purchase-motions-api": "/purchase-motions-api/static-1.6108",
  "signup-constants": "/signup-constants/static-1.19162",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8183",
  "usage-tracker-public": "/usage-tracker-public/static-1.7287",
  "reactive-lib": "/reactive-lib/static-1.851",
  "simple-logging-lib": "/simple-logging-lib/static-1.3174",
  "chatspot-core": "/chatspot-core/static-1.21897",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6704",
  "cms-field-types": "/cms-field-types/static-1.4940",
  "content-icons-ui": "/content-icons-ui/static-1.2261",
  "integrations-lib": "/integrations-lib/static-1.16544",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.425",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.901",
  "customer-data-tracking": "/customer-data-tracking/static-1.7012",
  "products-iframe-lib": "/products-iframe-lib/static-1.8273",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10654",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1190",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2181",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.462",
  "calling-error-reporting": "/calling-error-reporting/static-1.31443",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11161",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6669",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1461",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7372",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9613",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.138",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4097",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6924",
  "persist-promise": "/persist-promise/static-1.3826",
  "event-emitter": "/event-emitter/static-1.1075",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.232",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.405",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10355",
  "fsm": "/fsm/static-1.3856",
  "policy-lib": "/policy-lib/static-1.6911",
  "react-tinymce": "/react-tinymce/static-1.55571",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10418",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54697",
  "tinymce-plugins": "/tinymce-plugins/static-1.57811",
  "tinymce-themes": "/tinymce-themes/static-1.56667",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2298",
  "user-context-client": "/user-context-client/static-1.4705",
  "nest": "/nest/static-1.358",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.925",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4661",
  "video-embed": "/video-embed/static-1.36171",
  "social-insights-client-types": "/social-insights-client-types/static-1.22366",
  "flux-actions": "/flux-actions/static-1.347",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13959",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5732",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7907",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10487",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.643",
  "sales-views-client-types": "/sales-views-client-types/static-1.4382",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15138",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7730",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36238",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3678",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4636",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3168",
  "tinymce-data": "/tinymce-data/static-1.40782",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5336",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12690",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11665",
  "react-codemirror": "/react-codemirror/static-1.10753",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15726",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9146",
  "outpost": "/outpost/static-1.4293",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3137",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.36",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.409",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.600",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.745",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.55",
  "slack-ui-library": "/slack-ui-library/static-1.10522",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68804",
  "layout-data-lib": "/layout-data-lib/static-1.9990",
  "browser-eslint": "/browser-eslint/static-2.57",
  "advanced-menus-core": "/advanced-menus-core/static-1.15339",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12250",
  "ExportDialog": "/ExportDialog/static-6.10505",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34373",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15338",
  "simple-menus-lib": "/simple-menus-lib/static-1.16855"
}
};
